import { message } from "antd";
import { ClientError } from "graphql-request";
import { Redirect } from "react-router";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { SWRConfig } from "swr";
import "./App.css";
import DashboardPage from "./components/pages/DashboardPage/DashboardPage";
import EditUserPage from "./components/pages/EditUserPage/EditUserPage";
import ProfilePage from "./components/pages/ProfilePage/ProfilePage";
import UserManagementPage from "./components/pages/UserManagementPage/UserManagementPage";
import AuthRoute from "./navigation/AuthRole";
import KeycloakUserService from "./services/KeycloakUserService";

const App = () => {
  return (
    <SWRConfig
      value={{
        provider: () => new Map(),
        onError: (error) => {
          if (error instanceof ClientError) {
            if (error.response.errors[0].message === "Unauthorized") {
              message.error("Token is expired!").then();
              KeycloakUserService.doLogout();
            }
          }
        }
      }}
    >
      <div className="App">
        <Router>
          <Switch>
            <AuthRoute exact path="/usage-reports" Component={DashboardPage} requiredAuthentication />
            <AuthRoute exact path="/profile" Component={ProfilePage} requiredAuthentication />
            <AuthRoute exact path="/user-management" Component={UserManagementPage} requiredAuthentication />
            <AuthRoute exact path="/edit-user/:id" Component={EditUserPage} requiredAuthentication />
            <Route exact path="*" render={() => <Redirect to="/usage-reports" />} />
          </Switch>
        </Router>
      </div>
    </SWRConfig>
  );
};

export default App;
